"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var index_1 = require("../../index");
var lodash_1 = __importDefault(require("lodash"));
var INPUT_TYPES = {
  text: 'text',
  select: 'select'
};
var GenericInput = function GenericInput(props) {
  var label = props.label,
    name = props.name,
    type = props.type,
    rules = props.rules,
    _a = props.config,
    config = _a === void 0 ? {} : _a;
  if (type === INPUT_TYPES.text) {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Input, __assign({}, props)));
  } else {
    return react_1.default.createElement(antd_1.Form.Item, __assign({}, config, {
      name: name,
      label: label,
      rules: rules
    }), react_1.default.createElement(antd_1.Select, __assign({}, props, {
      options: __spreadArray([{
        label: props.placeholder,
        value: '',
        disabled: true
      }], props.options)
    })));
  }
};
var AntdAddressSetForm = function AntdAddressSetForm(props) {
  var form = props.form,
    _a = props.name,
    name = _a === void 0 ? null : _a,
    _b = props.isReadOnly,
    isReadOnly = _b === void 0 ? false : _b,
    _c = props.isRequired,
    isRequired = _c === void 0 ? true : _c,
    _d = props.enabledZip,
    enabledZip = _d === void 0 ? true : _d,
    _e = props.itemConfig,
    itemConfig = _e === void 0 ? {} : _e;
  var _f = react_1.useState([]),
    result = _f[0],
    setResult = _f[1];
  var _g = react_1.useState([]),
    cityOptions = _g[0],
    setCityOptions = _g[1];
  var _h = react_1.useState([]),
    districtOptions = _h[0],
    setDistrictOptions = _h[1];
  var NamedZip = react_1.default.useMemo(function () {
    return name ? name + "_zip" : 'zip';
  }, [name]);
  var NamedCity = react_1.default.useMemo(function () {
    return name ? name + "_city" : 'city';
  }, [name]);
  var NamedDistrict = react_1.default.useMemo(function () {
    return name ? name + "_district" : 'district';
  }, [name]);
  var NamedAddress = react_1.default.useMemo(function () {
    return name ? name + "_address" : 'address';
  }, [name]);
  react_1.useEffect(function () {
    var _fetch = function _fetch() {
      return __awaiter(void 0, void 0, void 0, function () {
        var _resp, result, districts;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, index_1.Cart.getZip3()];
            case 1:
              _resp = _a.sent();
              result = lodash_1.default.groupBy(_resp, function (z) {
                return z.city;
              });
              setCityOptions(Object.keys(result).map(function (c) {
                return {
                  label: c,
                  value: c
                };
              }));
              if (form.getFieldValue(NamedCity)) {
                districts = result[form.getFieldValue(NamedCity)];
                setDistrictOptions((districts || []).map(function (z) {
                  return {
                    label: z.district,
                    value: z.district
                  };
                }));
              }
              setResult(_resp);
              return [2 /*return*/];
          }
        });
      });
    };

    _fetch();
  }, [NamedCity, form]);
  var taiwan = react_1.useMemo(function () {
    return lodash_1.default.groupBy(result, function (z) {
      return z.city;
    });
  }, [result]);
  var getInputProps = react_1.useCallback(function (field) {
    return {
      zip: {
        label: '郵遞區號',
        name: NamedZip,
        value: form.getFieldValue(NamedZip),
        rules: [{
          len: 3,
          message: '郵遞區號必須為三碼'
        }],
        maxLength: 3,
        disabled: isReadOnly,
        onChange: function onChange(e) {
          return __awaiter(void 0, void 0, void 0, function () {
            var value, resp, district, city, districts, options;
            var _a, _b;
            return __generator(this, function (_c) {
              value = e.target.value;
              if (value.length === 3) {
                try {
                  resp = result.find(function (z) {
                    return z.zip === value;
                  });
                  district = resp.district, city = resp.city;
                  console.log(city, district);
                  districts = taiwan[city];
                  options = districts.map(function (z) {
                    return {
                      label: z.district,
                      value: z.district
                    };
                  });
                  setDistrictOptions(options);
                  form.setFieldsValue((_a = {}, _a[NamedZip] = value, _a[NamedCity] = city, _a[NamedDistrict] = district, _a));
                } catch (e) {
                  antd_1.message.error('查無此郵遞區號');
                  form.setFieldsValue((_b = {}, _b[NamedZip] = value, _b[NamedCity] = '', _b[NamedDistrict] = '', _b));
                }
              }
              return [2 /*return*/];
            });
          });
        },

        type: INPUT_TYPES.text,
        placeholder: '請輸入郵遞區號'
      },
      city: {
        label: '縣市',
        name: NamedCity,
        value: form.getFieldValue(NamedCity),
        rules: [{
          required: isRequired,
          message: '縣市為必填值'
        }],
        disabled: isReadOnly,
        onChange: function onChange(value) {
          return __awaiter(void 0, void 0, void 0, function () {
            var districts, options;
            var _a, _b;
            return __generator(this, function (_c) {
              if (enabledZip) {
                form.setFieldsValue((_a = {}, _a[NamedCity] = value, _a[NamedDistrict] = '', _a[NamedZip] = '', _a));
              } else {
                form.setFieldsValue((_b = {}, _b[NamedCity] = value, _b[NamedDistrict] = '', _b));
              }
              districts = taiwan[value];
              options = districts.map(function (z) {
                return {
                  label: z.district,
                  value: z.district
                };
              });
              setDistrictOptions(options);
              return [2 /*return*/];
            });
          });
        },

        type: INPUT_TYPES.select,
        options: cityOptions,
        placeholder: '請選擇縣市'
      },
      district: {
        label: '鄉鎮市區',
        name: NamedDistrict,
        value: form.getFieldValue(NamedDistrict),
        rules: [{
          required: isRequired,
          message: '鄉鎮市區為必填值'
        }],
        disabled: isReadOnly,
        onChange: function onChange(value) {
          return __awaiter(void 0, void 0, void 0, function () {
            var districts, targetDistrict;
            var _a, _b;
            return __generator(this, function (_c) {
              if (enabledZip) {
                districts = taiwan[form.getFieldValue(NamedCity)];
                targetDistrict = districts.find(function (z) {
                  return z.district === value;
                });
                form.setFieldsValue((_a = {}, _a[NamedDistrict] = value, _a[NamedZip] = (targetDistrict === null || targetDistrict === void 0 ? void 0 : targetDistrict.zip) || '', _a));
              } else {
                form.setFieldsValue((_b = {}, _b[NamedDistrict] = value, _b));
              }
              return [2 /*return*/];
            });
          });
        },

        type: INPUT_TYPES.select,
        options: districtOptions,
        placeholder: '請選擇鄉鎮市區'
      },
      address: {
        label: '地址',
        name: NamedAddress,
        value: form.getFieldValue(NamedAddress),
        rules: [{
          required: isRequired,
          message: '地址為必填值'
        }],
        disabled: isReadOnly,
        onChange: function onChange(e) {
          var _a;
          form.setFieldsValue((_a = {}, _a[NamedAddress] = e.target.value, _a));
        },
        type: INPUT_TYPES.text,
        placeholder: '請輸入地址'
      }
    }[field];
  }, [NamedAddress, NamedCity, NamedDistrict, NamedZip, cityOptions, districtOptions, enabledZip, form, isReadOnly, isRequired, result, taiwan]);
  return react_1.default.createElement(react_1.Fragment, null, enabledZip && react_1.default.createElement(GenericInput, __assign({
    config: itemConfig
  }, getInputProps('zip'))), react_1.default.createElement(GenericInput, __assign({
    config: itemConfig
  }, getInputProps('city'))), react_1.default.createElement(GenericInput, __assign({
    config: itemConfig
  }, getInputProps('district'))), react_1.default.createElement(GenericInput, __assign({
    config: itemConfig
  }, getInputProps('address'))));
};
exports.default = AntdAddressSetForm;